module.exports = __webpack_public_path__ + "media/pl_pl_s5_Natasza.621f8fde.oga";